var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable } from 'mobx';
class CookieConsentStore {
    constructor() {
        Object.defineProperty(this, "isCookiebotEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cookieConsents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "evaluateCookiebotEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a, _b, _c;
                const isCookiebotLoaded = !!((_a = window.CookieControl) === null || _a === void 0 ? void 0 : _a.Dialog) || ((_b = window.Cookiebot) === null || _b === void 0 ? void 0 : _b.consented) || ((_c = window.Cookiebot) === null || _c === void 0 ? void 0 : _c.declined);
                this.isCookiebotEnabled = isCookiebotLoaded || this.isCookiebotBlocked();
            }
        });
        Object.defineProperty(this, "isCookiebotBlocked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return !!window.Cookiebot && !window.CookieControl;
            }
        });
        Object.defineProperty(this, "setListeners", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                window.addEventListener('CookiebotOnLoad', () => {
                    this.evaluateCookiebotEnabled();
                    this.setCookieConsents();
                });
                window.addEventListener('CookiebotOnDialogInit', () => this.evaluateCookiebotEnabled());
            }
        });
        Object.defineProperty(this, "setCookieConsents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a;
                this.cookieConsents = ((_a = window.Cookiebot) === null || _a === void 0 ? void 0 : _a.consent) || { necessary: true };
            }
        });
        makeObservable(this);
        this.evaluateCookiebotEnabled();
        this.setListeners();
        if (this.isCookiebotEnabled) {
            this.setCookieConsents();
        }
    }
}
__decorate([
    observable
], CookieConsentStore.prototype, "isCookiebotEnabled", void 0);
__decorate([
    observable
], CookieConsentStore.prototype, "cookieConsents", void 0);
__decorate([
    action.bound
], CookieConsentStore.prototype, "evaluateCookiebotEnabled", void 0);
__decorate([
    action.bound
], CookieConsentStore.prototype, "setCookieConsents", void 0);
export default CookieConsentStore;
